import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { validate as isValidUUID } from 'uuid';

@Directive({
  selector: '[scipUuidValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: UuidValidatorDirective, multi: true }]
})
export class UuidValidatorDirective implements Validator {
  static uuid(control: AbstractControl): ValidationErrors | null {
    if (control.value && control.value.length > 0 && !isValidUUID(control.value.toString())) {
      return { uuid: { value: control.value } };
    } 
    return null;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return UuidValidatorDirective.uuid(control);
  }
}
